import { History } from "history";

import {
  CreateSkillRequest,
  PaginateQuery,
  UpdateSkillRequest,
  SkillDto,
  SkillsSuggestionRequest,
  CopyCutSkillRequest,
} from "../../interfaces";
import { Paginated } from "../../models";
import { MediaDto } from "../../interfaces/media";

//#region Get Skills

export const GET_SKILLS = "GET_SKILLS";
export const GET_SKILLS_SUCCESS: any = "GET_SKILLS_SUCCESS";
export const GET_SKILLS_ERROR: any = "GET_SKILLS_ERROR";

export interface GetSkillsAction {
  type: typeof GET_SKILLS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetSkillsSuccessAction {
  type: typeof GET_SKILLS_SUCCESS;
  payload: Paginated<SkillDto>;
}

export interface GetSkillsErrorAction {
  type: typeof GET_SKILLS_ERROR;
  payload: any;
}
//#endregion

//#region Get Skills by Lesson Id

export const GET_SKILLS_BY_LESSON = "GET_SKILLS_BY_LESSON";
export const GET_SKILLS_BY_LESSON_SUCCESS: any = "GET_SKILLS_BY_LESSON_SUCCESS";
export const GET_SKILLS_BY_LESSON_ERROR: any = "GET_SKILLS_BY_LESSON_ERROR";

export interface GetSkillsByLessonAction {
  type: typeof GET_SKILLS_BY_LESSON;
  payload: {
    lessonId: string;
    history: History;
  };
}

export interface GetSkillsByLessonSuccessAction {
  type: typeof GET_SKILLS_BY_LESSON_SUCCESS;
  payload: SkillDto[];
}

export interface GetSkillsByLessonErrorAction {
  type: typeof GET_SKILLS_BY_LESSON_ERROR;
  payload: any;
}
//#endregion

//#region Get Skills by Subject Id

export const GET_SKILLS_BY_SUBJECT = "GET_SKILLS_BY_SUBJECT";
export const GET_SKILLS_BY_SUBJECT_SUCCESS: any =
  "GET_SKILLS_BY_SUBJECT_SUCCESS";
export const GET_SKILLS_BY_SUBJECT_ERROR: any = "GET_SKILLS_BY_SUBJECT_ERROR";

export interface GetSkillsBySubjectAction {
  type: typeof GET_SKILLS_BY_SUBJECT;
  payload: {
    subjectId: string;
    history: History;
  };
}

export interface GetSkillsBySubjectSuccessAction {
  type: typeof GET_SKILLS_BY_SUBJECT_SUCCESS;
  payload: SkillDto[];
}

export interface GetSkillsBySubjectErrorAction {
  type: typeof GET_SKILLS_BY_SUBJECT_ERROR;
  payload: any;
}
//#endregion

//#region Get Skill

export const GET_SKILL = "GET_SKILL";
export const GET_SKILL_SUCCESS: any = "GET_SKILL_SUCCESS";
export const GET_SKILL_ERROR: any = "GET_SKILL_ERROR";

export interface GetSkillAction {
  type: typeof GET_SKILL;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetSkillSuccessAction {
  type: typeof GET_SKILL_SUCCESS;
  payload: SkillDto;
}

export interface GetSkillErrorAction {
  type: typeof GET_SKILL_ERROR;
  payload: any;
}
//#endregion

//#region Add Skill

export const ADD_SKILL = "ADD_SKILL";
export const ADD_SKILL_SUCCESS: any = "ADD_SKILL_SUCCESS";
export const ADD_SKILL_ERROR: any = "ADD_SKILL_ERROR";

export interface AddSkillAction {
  type: typeof ADD_SKILL;
  payload: {
    request: CreateSkillRequest;
    history: History;
  };
}

export interface AddSkillSuccessAction {
  type: typeof ADD_SKILL_SUCCESS;
  payload: SkillDto;
}

export interface AddSkillErrorAction {
  type: typeof ADD_SKILL_ERROR;
  payload: any;
}
//#endregion

//#region Update Skill

export const UPDATE_SKILL = "UPDATE_SKILL";
export const UPDATE_SKILL_SUCCESS: any = "UPDATE_SKILL_SUCCESS";
export const UPDATE_SKILL_ERROR: any = "UPDATE_SKILL_ERROR";

export interface UpdateSkillAction {
  type: typeof UPDATE_SKILL;
  payload: {
    id: string;
    request: UpdateSkillRequest;
    history: History;
  };
}

export interface UpdateSkillSuccessAction {
  type: typeof UPDATE_SKILL_SUCCESS;
  payload: SkillDto;
}

export interface UpdateSkillErrorAction {
  type: typeof UPDATE_SKILL_ERROR;
  payload: any;
}
//#endregion

//#region Delete Skill

export const DELETE_SKILL_CONSENT: any = "DELETE_SKILL_CONSENT";
export const DELETE_SKILL = "DELETE_SKILL";
export const DELETE_SKILL_SUCCESS: any = "DELETE_SKILL_SUCCESS";
export const DELETE_SKILL_ERROR: any = "DELETE_SKILL_ERROR";

export interface DeleteSkillConsentAction {
  type: typeof DELETE_SKILL_CONSENT;
  payload: string;
}

export interface DeleteSkillAction {
  type: typeof DELETE_SKILL;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteSkillSuccessAction {
  type: typeof DELETE_SKILL_SUCCESS;
  payload: string;
}

export interface DeleteSkillErrorAction {
  type: typeof DELETE_SKILL_ERROR;
  payload: any;
}
//#endregion

//#region Upload Skill Video

export const UPLOAD_SKILL_VIDEO = "UPLOAD_SKILL_VIDEO";
export const UPLOAD_SKILL_VIDEO_SUCCESS: any = "UPLOAD_SKILL_VIDEO_SUCCESS";
export const UPLOAD_SKILL_VIDEO_ERROR: any = "UPLOAD_SKILL_VIDEO_ERROR";
export const UPLOAD_SKILL_VIDEO_PROGRESS: any = "UPLOAD_SKILL_VIDEO_PROGRESS";

export interface UploadSkillVideoAction {
  type: typeof UPLOAD_SKILL_VIDEO;
  payload: {
    file: File;
    history: History;
    skillId?: string;
  };
}
export interface UploadSkillVideoSuccessAction {
  type: typeof UPLOAD_SKILL_VIDEO_SUCCESS;
  payload: MediaDto;
}

export interface UploadSkillVideoErrorAction {
  type: typeof UPLOAD_SKILL_VIDEO_ERROR;
  payload: any;
}

export interface UploadSkillVideoProgressAction {
  type: typeof UPLOAD_SKILL_VIDEO_PROGRESS;
  payload: number;
}

//#endregion

//#region add edit skill modal
export const TOGGLE_ADD_EDIT_SKILL_MODAL: any = "TOGGLE_ADD_EDIT_SKILL_MODAL";

export interface ToggleAddEditSkillModalAction {
  type: typeof TOGGLE_ADD_EDIT_SKILL_MODAL;
  payload: any;
}
//#endregion

//#region Get Skills Suggestion

export const GET_SKILLS_SUGGESTION = "GET_SKILLS_SUGGESTION";
export const GET_SKILLS_SUGGESTION_SUCCESS: any =
  "GET_SKILLS_SUGGESTION_SUCCESS";
export const GET_SKILLS_SUGGESTION_ERROR: any = "GET_SKILLS_SUGGESTION_ERROR";

export interface GetSkillsSuggestionAction {
  type: typeof GET_SKILLS_SUGGESTION;
  payload: { request: SkillsSuggestionRequest };
}
export interface GetSkillsSuggestionSuccessAction {
  type: typeof GET_SKILLS_SUGGESTION_SUCCESS;
  payload: SkillDto[];
}

export interface GetSkillsSuggestionErrorAction {
  type: typeof GET_SKILLS_SUGGESTION_ERROR;
  payload: any;
}
//#endregion

//#region Toggle Skill State

export const TOGGLE_SKILL_STATE_CONSENT: any = "TOGGLE_SKILL_STATE_CONSENT";
export const TOGGLE_SKILL_STATE = "TOGGLE_SKILL_STATE";
export const TOGGLE_SKILL_STATE_SUCCESS: any = "TOGGLE_SKILL_STATE_SUCCESS";
export const TOGGLE_SKILL_STATE_ERROR: any = "TOGGLE_SKILL_STATE_ERROR";

export interface ToggleSkillStateConsentAction {
  type: typeof TOGGLE_SKILL_STATE_CONSENT;
  payload: string;
}

export interface ToggleSkillStateAction {
  type: typeof TOGGLE_SKILL_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface ToggleSkillStateSuccessAction {
  type: typeof TOGGLE_SKILL_STATE_SUCCESS;
  payload: { id: string };
}

export interface ToggleSkillStateErrorAction {
  type: typeof TOGGLE_SKILL_STATE_ERROR;
  payload: any;
}
//#endregion

//#region Toggle Skill State

export const COPY_SKILLS = "COPY_SKILLS";
export const COPY_SKILLS_SUCCESS: any = "COPY_SKILLS_SUCCESS";
export const COPY_SKILLS_ERROR: any = "COPY_SKILLS_ERROR";
export const RESET_COPY_CUT_SKILLS: any = "RESET_COPY_CUT_SKILLS";

export interface CopySkillsAction {
  type: typeof COPY_SKILLS;
  payload: { request: CopyCutSkillRequest };
}

export interface CopySkillsSuccessAction {
  type: typeof COPY_SKILLS_SUCCESS;
  payload: null;
}

export interface CopySkillsErrorAction {
  type: typeof COPY_SKILLS_ERROR;
  payload: any;
}

export interface CopySkillsResetAction {
  type: typeof RESET_COPY_CUT_SKILLS;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetSkillsAction
  | GetSkillsSuccessAction
  | GetSkillsErrorAction
  | GetSkillsByLessonAction
  | GetSkillsByLessonSuccessAction
  | GetSkillsByLessonErrorAction
  | GetSkillAction
  | GetSkillSuccessAction
  | GetSkillErrorAction
  | AddSkillAction
  | AddSkillSuccessAction
  | AddSkillErrorAction
  | UpdateSkillAction
  | UpdateSkillSuccessAction
  | UpdateSkillErrorAction
  | DeleteSkillConsentAction
  | DeleteSkillAction
  | DeleteSkillSuccessAction
  | DeleteSkillErrorAction
  | UploadSkillVideoAction
  | UploadSkillVideoSuccessAction
  | UploadSkillVideoErrorAction
  | UploadSkillVideoProgressAction
  | GetSkillsSuggestionAction
  | GetSkillsSuggestionSuccessAction
  | GetSkillsSuggestionErrorAction
  | CopySkillsAction
  | CopySkillsSuccessAction
  | CopySkillsErrorAction;
